/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentDetailStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceAssessmentDetailStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceAssessmentDetailStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentDetailStatusQueryOperator>): ComplianceAssessmentDetailStatusQueryOperator {
        let obj = Object.assign(new ComplianceAssessmentDetailStatusQueryOperator(), model);
        ComplianceAssessmentDetailStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentDetailStatusQueryOperator>): ComplianceAssessmentDetailStatusQueryOperator {
        if (!model) return null;
        return ComplianceAssessmentDetailStatusQueryOperator.newInstance(<ComplianceAssessmentDetailStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentDetailStatusQueryOperator) {
        if (!obj) return;

        models.ComplianceAssessmentDetailStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentDetailStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceAssessmentDetailStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Compliance control statuses to include
     */
    statuses: Array<models.ComplianceControlStatus>;

}
